const Notification = ({ notification }) => {
  const handleAccept = () => {}

  const handleDecline = () => {}

  return (
    <div className="w-full py-[16px] pl-[16px] pr-[38px] bg-[#FFF5EE] rounded-[10px] flex items-center border-[#ff9154] border-[1px]">
      <div
        style={{ backgroundColor: notification.mark ? '#F79009' : 'transparent' }}
        className="w-[12px] h-[12px] rounded-full"
      />

      <img
        src={notification.image}
        alt="Notification"
        width={36}
        height={36}
        className="ml-[10px] w-[36px] h-[36px] rounded-full mr-[16px]"
      />

      <div className="flex-1 flex flex-col items-start">
        <div className="flex items-start">
          <h3
            className="font-medium text-base font-Inter text-[#F67443]"
            dangerouslySetInnerHTML={{ __html: notification.title }}
          ></h3>

          {notification.new && (
            <span className="float-left flex items-center justify-center ml-[10px] rounded-[4px] bg-[#F79009] px-[8px] h-[24px] text-xs font-normal font-Inter text-[#FDFDFD]">
              New!
            </span>
          )}
        </div>

        <h4
          className={`mt-[4px] text-sm font-normal font-Inter ${notification.reason ? 'text-[#FAB258]' : 'text-[#F79009]'}`}
        >
          {notification.description}
        </h4>

        {notification.reason && (
          <span
            role="alert"
            className="mt-[10px] bg-white rounded-[8px] px-[16px] h-[40px] flex items-center justify-center text-sm font-normal font-Inter text-[#F79009]"
          >
            Reason: "{notification.reason}"
          </span>
        )}

        {notification.accept && (
          <div className="mt-[10px] gap-x-[10px] flex items-center">
            <button
              className="w-[200px] h-[32px] flex items-center justify-center rounded-[8px] bg-[#1AC057] hover:bg-[#17aa59] shadow-button text-sm font-semibold text-white font-Inter transition-colors duration-200 ease"
              onClick={handleAccept}
            >
              Accept
            </button>

            <button
              className="w-[200px] h-[32px] flex items-center justify-center rounded-[8px] bg-[#EF4343] hover:bg-[#d41212] shadow-button text-sm font-semibold text-white font-Inter transition-colors duration-200 ease"
              onClick={handleDecline}
            >
              Decline
            </button>
          </div>
        )}
      </div>

      <span className="ml-[25px] text-sm font-normal font-Inter text-[#F79009]">
        {notification.date}
      </span>
    </div>
  )
}

export default Notification
